"use client";
import * as React from "react";
import { Info, LucideIcon } from "lucide-react";
export interface PageMetaBarV2Props {
  icon: LucideIcon | React.ComponentType<{ className?: string }>;
  summary: React.ReactNode;
  pageInfo?: React.ReactNode;
}
export function PageMetaBarV2({
  icon: Icon,
  summary,
  pageInfo}: PageMetaBarV2Props) {
  return (
    <div className="flex flex-col gap-2 border-y border-slate-200/70 py-3 dark:border-zinc-800 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-2 text-sm font-medium text-slate-700 dark:text-zinc-200">
        <Icon className="h-4 w-4 text-indigo-500" />
        <span>{summary}</span>
      </div>
      {pageInfo ? (
        <div className="inline-flex items-center gap-2 text-xs font-medium text-slate-500 dark:text-zinc-400">
          <Info className="h-3.5 w-3.5" />
          <span>{pageInfo}</span>
        </div>
      ) : null}
    </div>
  );
}
